<template>
  <div class="container accueil">
    <!-- Étape 1 : Formulaire -->
    <div v-show="!showRecap">
      <Introduction />

      <form @submit.prevent="valideStepOne" class="formulaire card" name="inscription-scolaires">
        <div>
          <div class="div_sous_titre">
            <div class="sous_titre">

              <h3 class="titre_parties">Identité de l'élève *</h3>
            </div>
          </div>

          <div
            v-if="['formulaire-cas-2', 'formulaire-cas-3'].indexOf($route.name) > -1"
            class="champ row div_photo_input"
          >
            <span class="label col-md-4 col-12">Photo de l'élève *</span>
            <div class="col-lg-2 div_photo_input">
              <img
                id="photoEleve"
                :src="photoEleveUrl"
                alt="Photo Elève"
                class="mx-auto border"
                style="display: block; height: 150px; object-fit: contain;"
              />
            </div>
            <div class="input col">
              <input
                ref="filePhoto"
                type="file"
                class="form-control input_photo_eleve"
                accept="image/jpeg"
                @change="uploadImage($event)"
                required
              />
              <div class="form-text">Taille maximale de fichier autorisée : 5Mo.</div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Sexe *</span>
            <div class="input col-md-8 col-12 d-flex gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="genreEleve"
                  value="M"
                  id="genreM"
                  :disabled="isReinscription"
                  required
                />
                <label class="form-check-label" for="genreM">Garçon</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="genreEleve"
                  value="F"
                  id="genreF"
                  :disabled="isReinscription"
                />
                <label class="form-check-label" for="genreF">Fille</label>
              </div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Nom *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="Le nom de votre enfant"
                v-model="nomEleve"
                type="text"
                :disabled="isReinscription"
                required
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Prénom *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="Le prénom de votre enfant"
                v-model="prenomEleve"
                type="text"
                :disabled="isReinscription"
                required
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Date de naissance *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="YYYY-MM-DD"
                v-model="naissanceEleve"
                type="date"
                :max="dateMax"
                :disabled="isReinscription"
                required
              />
            </div>
          </div>
        </div>

        <div>
          <div class="div_sous_titre">
            <div class="sous_titre">

              <h3 class="titre_parties">Informations responsables légaux *</h3>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Civilité *</span>
            <div class="input col-md-8 col-12 d-flex gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="genreParent"
                  value="M"
                  id="parentM"
                  required
                />
                <label class="form-check-label" for="parentM">Monsieur</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="genreParent"
                  value="F"
                  id="parentF"
                />
                <label class="form-check-label" for="parentF">Madame</label>
              </div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Nom *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="Votre nom"
                v-model="nomParent"
                type="text"
                required
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Prénom *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="Votre prénom"
                v-model="prenomParent"
                type="text"
                required
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Code Postal *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                placeholder="54200"
                v-model="codePostalParent1"
                pattern="[0-9]{5}"
                minlength="5"
                maxlength="5"
                type="tel"
                required
                @input="valideCodePostalParent1"
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Commune *</span>
            <div class="input col-md-8 col-12">
              <select
                class="form-select"
                v-model="communeParent1"
                @change="valideCommuneParent1"
                required
              >
                <option
                  v-for="(ville, id) in villesParent1"
                  :key="id"
                  :value="ville.nom"
                >
                  {{ ville.nom }}
                </option>
              </select>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Adresse *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                @input="valideRueParent1"
                autocomplete="off"
                v-model="adresseParent1"
                type="text"
                name="proposition"
                required
                placeholder="10 rue du Général de Gaulle"
              />
              <div v-if="ruesParent1" v-show="fenetreParent1" class="fenetre_autocomplete">
                <button
                  type="button"
                  class="proposition btn"
                  @click="selectReponse(ruesParent1)"
                >
                  {{ ruesParent1.features[0].properties.name }}
                </button>
              </div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Complément d'adresse</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                v-model="complementParent1"
                type="text"
                placeholder="Bâtiment 2 Etage 3"
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Téléphone *</span>
            <div class="input col-md-8 col-12">
              <input
                class="form-control"
                v-model="telephone"
                pattern="0[1-9][0-9]{8}"
                type="tel"
                minlength="10"
                maxlength="10"
                required
              />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Email *</span>
            <div class="input col-md-8 col-12">
              <input class="form-control" v-model="email" type="email" required />
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Info réseau</span>
            <div class="input col-md-8 col-12">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="aboInfoReseauEmail"
                  v-model="aboInfoReseauEmail"
                />
                <label class="form-check-label" for="aboInfoReseauEmail">
                  Je souhaite être informé par email des informations du réseau.
                </label>
              </div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Garde Alternée *</span>
            <div class="input col-md-8 col-12 d-flex gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="gardeAlternee"
                  value="false"
                  id="gardeNon"
                  required
                />
                <label class="form-check-label" for="gardeNon">Non</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="gardeAlternee"
                  value="true"
                  id="gardeOui"
                />
                <label class="form-check-label" for="gardeOui">Oui</label>
              </div>
            </div>
          </div>

          <div class="info_garde_alternee" v-if="gardeAlternee === 'true'">
            <div class="champ row">
              <span class="label col-md-4 col-12">Nom et Prénom *</span>
              <div class="input col-md-8 col-12">
                <input
                  class="form-control"
                  placeholder="Le nom et prénom du second parent"
                  v-model="nomPrenomParent2"
                  type="text"
                  required
                />
              </div>
            </div>

            <div class="champ row">
              <span class="label col-md-4 col-12">Code Postal *</span>
              <div class="input col-md-8 col-12">
                <input
                  class="form-control"
                  placeholder="54200"
                  v-model="codePostalParent2"
                  pattern="[0-9]{5}"
                  minlength="5"
                  maxlength="5"
                  type="tel"
                  required
                  @input="valideCodePostalParent2"
                />
              </div>
            </div>

            <div class="champ row">
              <span class="label col-md-4 col-12">Commune *</span>
              <div class="input col-md-8 col-12">
                <select
                  class="form-select"
                  v-model="communeParent2"
                  @change="valideCommuneParent2"
                  required
                >
                  <option
                    v-for="(ville, id) in villesParent2"
                    :key="id"
                    :value="ville.nom"
                  >
                    {{ ville.nom }}
                  </option>
                </select>
              </div>
            </div>

            <div class="champ row">
              <span class="label col-md-4 col-12">Adresse *</span>
              <div class="input col-md-8 col-12">
                <input
                  class="form-control"
                  @input="valideRueParent2"
                  autocomplete="off"
                  v-model="adresseParent2"
                  type="text"
                  name="proposition"
                  required
                  placeholder="10 rue du Général de Gaulle"
                />
                <div v-if="ruesParent2" v-show="fenetreParent2" class="fenetre_autocomplete">
                  <button
                    type="button"
                    class="proposition btn"
                    @click="selectReponseParent2(ruesParent2)"
                  >
                    {{ ruesParent2.features[0].properties.name }}
                  </button>
                </div>
              </div>
            </div>

            <div class="champ row">
              <span class="label col-md-4 col-12">Complément d'adresse</span>
              <div class="input col-md-8 col-12">
                <input
                  class="form-control"
                  v-model="complementParent2"
                  type="text"
                  placeholder="Bâtiment 2 Etage 3"
                />
              </div>
            </div>
          </div>

        </div>

        <div>
          <div class="div_sous_titre">
            <div class="sous_titre">

              <h3 class="titre_parties">Établissement scolaire *</h3>
            </div>
          </div>

          <div class="div_info_etablissement_scolaire">
            <span id="info_etablissement_primaire" v-if="$route.name === 'formulaire-cas-1' || $route.name === 'reinscription-formulaire-cas-1'">
              Si votre école primaire ou maternelle n'est pas sur le territoire de la CC2T, votre demande doit
              être adressée à
              <a id="lien_fluo" href="https://www.fluo.eu/54">www.fluo.eu/54</a>
            </span>
          </div>

          <div
            v-if="
              ['formulaire-cas-1', 'reinscription-formulaire-cas-1', 'formulaire-cas-2', 'reinscription-formulaire-cas-2'].indexOf($route.name) > -1
            "
            class="champ row"
          >
            <span class="label col-md-4 col-12">Établissement *</span>
            <div class="input col-md-8 col-12">
              <select class="form-select" required v-model="etablissement">
                <optgroup
                  v-for="(groupe, id) in etablissementsDonnees"
                  :key="id"
                  :label="groupe.libelle"
                >
                  <option
                    v-for="(etab, id2) in groupe.etablissements"
                    :key="id2"
                    :value="etab"
                  >
                    {{ etab.libelle }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>

          <div
            v-if="$route.name === 'formulaire-cas-3' || $route.name === 'reinscription-formulaire-cas-3'"
          >
            <div class="champ row">
              <span class="label col-md-4 col-12">Établissement *</span>
              <div class="input col-md-8 col-12">
                <input
                  class="form-control"
                  v-model="etablissementAutre"
                  type="text"
                  required
                />
              </div>
            </div>
          </div>

          <div class="champ row">
            <span class="label col-md-4 col-12">Classe *</span>
            <div class="input col-md-8 col-12">
              <select class="form-select" required v-model="classe">
                <optgroup
                  v-for="(groupe, id) in classesDonnees"
                  :key="id"
                  :label="groupe.libelle"
                >
                  <option
                    v-for="(cl, id2) in groupe.classes"
                    :key="id2"
                    :value="cl"
                  >
                    {{ cl.libelle }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>

          <div
            v-if="
              ['formulaire-cas-2', 'formulaire-cas-3', 'reinscription-formulaire-cas-2', 'reinscription-formulaire-cas-3'].indexOf($route.name) > -1
            "
            class="champ row"
          >
            <span class="label col-md-4 col-12">Régime *</span>
            <div class="input col-md-8 col-12 d-flex gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="regime"
                  value="Interne"
                  id="regimeInterne"
                  required
                />
                <label class="form-check-label" for="regimeInterne">Interne</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="regime"
                  value="1/2 pension"
                  id="regimeDemi"
                />
                <label class="form-check-label" for="regimeDemi">1/2 pension</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="regime"
                  value="Externe"
                  id="regimeExterne"
                />
                <label class="form-check-label" for="regimeExterne">Externe</label>
              </div>
            </div>
          </div>

          <div class="div_twobtns row">
            <div class="col-6 div_suivant">
              <button type="submit" class="btn btn-lg boutons_fin">
                SUIVANT <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Étape 2 : Récapitulatif + Validation -->
    <div v-show="showRecap">
      <h1 class="bloc_intro_renseignements">Récapitulatif de vos renseignements</h1>

      <div class="formulaire">
        <div class="div_sous_titre">
          <div class="sous_titre">

            <h3 class="titre_parties">Vos renseignements</h3>
          </div>
        </div>

        <Recapitulatif
          v-if="classe && (etablissement || etablissementAutre)"
          :nomEleve="nomEleve"
          :prenomEleve="prenomEleve"
          :naissanceEleve="formatDate(naissanceEleve)"
          :nomParent="nomParent"
          :prenomParent="prenomParent"
          :adresse="adresseParent1"
          :complement="complementParent1"
          :codePostal="codePostalParent1"
          :commune="communeParent1"
          :telephone="telephone"
          :email="email"
          :gardeAlternee="gardeAlternee"
          :etablissement="etablissement === null ? etablissementAutre : etablissement.libelle"
          :classe="classe.libelle"
          :regime="regime === null ? 'Pas de régime à spécifier' : regime"
          :nomParents2="nomPrenomParent2"
          :adresseParent2="adresseParent2"
          :codePostalParent2="codePostalParent2"
          :communeParent2="communeParent2"
          :complementParent2="complementParent2"
        />

        <div class="div_twobtns">
          <div class="div_retour">
            <button @click="retour" class="btn btn-lg boutons_fin">
              <i class="fas fa-arrow-left"></i> Revenir au formulaire
            </button>
          </div>
        </div>
      </div>

      <form @submit.prevent="valideStepTwo" class="formulaire card">
        <div>
          <div class="div_sous_titre">
            <div class="sous_titre">
  
              <h3 class="titre_parties">Règlements</h3>
            </div>
          </div>
          <h4>Règlement de Transport *</h4>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="checkReglement" name="reglement" required />
            <label class="form-check-label" for="checkReglement">
              J'atteste avoir pris connaissance et m'engage à respecter et ou faire respecter les règlements
              disponibles en téléchargement :
              <a
                class="liens_reglements_mentions"
                target="blank"
                href="https://www.reseau-colibri.fr/assets/pdf/reglement-transport-2020-11-12.pdf"
                >Règlements des transports scolaires Colibri</a
              >
            </label>
          </div>
        </div>

        <div>
          <h4>Attestation sur l'Honneur *</h4>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="checkAttestation"
              name="attestation"
              required
            />
            <label class="form-check-label" for="checkAttestation">
              J'atteste de l'exactitude des informations fournies.
            </label>
          </div>
        </div>

        <div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="checkMentions"
              name="mentions"
              required
            />
            <label class="form-check-label" for="checkMentions">
              J'ai pris connaissance et accepte la politique de confidentialité et de sécurité des données
              personnelles du réseau Colibri :
              <a
                class="liens_reglements_mentions"
                target="blank"
                href="https://www.reseau-colibri.fr/assets/pdf/mentions_legales.pdf"
                >Mentions légales</a
              >
            </label>
          </div>
        </div>

        <div class="div_twobtns">
          <div class="div_suivant">
            <button type="submit" class="btn btn-lg boutons_fin">
              Valider l'inscription <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router/index.js'
import avatarUrl from '../assets/avatar.png'
import Recapitulatif from '../components/Recapitulatif.vue'
import Introduction from '../components/Introduction.vue'

export default {
  name: 'Formulaire',
  components: { Introduction, Recapitulatif },
  data() {
    return {
      showRecap: false,
      demande: null,
      rechargementId: null,
      photoEleveFile: null,
      photoEleve: null,
      photoEleveUrl: avatarUrl,
      genreEleve: null,
      nomEleve: null,
      prenomEleve: null,
      naissanceEleve: null,
      genreParent: null,
      nomParent: null,
      prenomParent: null,
      nomPrenomParent2: null,

      adresseParent1: null,
      complementParent1: null,
      codePostalParent1: null,
      communeParent1: null,
      adresseParent2: null,
      complementParent2: null,
      codePostalParent2: null,
      communeParent2: null,

      telephone: null,
      email: null,
      aboInfoReseauEmail: false,
      gardeAlternee: null,
      etablissement: null,
      etablissementAutre: null,
      classe: null,
      regime: null,

      longitudeParent1: null,
      latitudeParent1: null,
      longitudeParent2: null,
      latitudeParent2: null,

      geocodeParent1: null,
      geocodeParent2: null,

      dateMax: new Date().toISOString().split('T')[0],

      villesParent1: null,
      villesParent2: null,
      codeVille: null,
      ruesParent1: null,
      ruesParent2: null,
      fenetreParent1: false,
      fenetreParent2: false,
      adresseSelectionneeParent1: '',
      adresseSelectionneeParent2: '',

      etablissementsDonnees: [],
      classesDonnees: [],
    }
  },

  computed: {
    isReinscription() {
      return (
        this.$route.name === 'reinscription-formulaire-cas-2' ||
        this.$route.name === 'reinscription-formulaire-cas-3'
      )
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    valideCodePostalParent1() {
      if (this.codePostalParent1.length === 5) {
        axios
          .get('https://geo.api.gouv.fr/communes?codePostal=' + this.codePostalParent1)
          .then(response => {
            const exclusions = [
              'Bulligny', 'Crézilles', 'Moutrot', 'Blénod-lès-Toul', 'Mont-le-Vignoble',
              'Rosières-en-Haye', 'Liverdun', 'Saizerais', 'Beaumont', 'Bernécourt',
              'Bouillonville', 'Charey', 'Dampvitoux', 'Dommartin-la-Chaussée',
              'Essey-et-Maizerais', 'Euvezin', 'Fey-en-Haye', 'Flirey', 'Hagéville',
              'Hamonville', 'Jaulny', 'Limey-Remenauville', 'Lironville', 'Mamey',
              'Mandres-aux-Quatre-Tours', 'Pannes', 'Rembercourt-sur-Mad', 'Saint-Baussant',
              'Saint-Julien-lès-Gorze', 'Seicheprey', 'Thiaucourt-Regniéville',
              'Viéville-en-Haye', 'Xammes',
            ]
            this.villesParent1 = response.data.filter(v => !exclusions.includes(v.nom))
          })
          .catch(console.log)
      }
    },

    valideCodePostalParent2() {
      if (this.codePostalParent2.length === 5) {
        axios
          .get('https://geo.api.gouv.fr/communes?codePostal=' + this.codePostalParent2)
          .then(response => {
            const exclusions = [
              'Bulligny', 'Crézilles', 'Moutrot', 'Blénod-lès-Toul', 'Mont-le-Vignoble',
              'Rosières-en-Haye', 'Liverdun', 'Saizerais', 'Beaumont', 'Bernécourt',
              'Bouillonville', 'Charey', 'Dampvitoux', 'Dommartin-la-Chaussée',
              'Essey-et-Maizerais', 'Euvezin', 'Fey-en-Haye', 'Flirey', 'Hagéville',
              'Hamonville', 'Jaulny', 'Limey-Remenauville', 'Lironville', 'Mamey',
              'Mandres-aux-Quatre-Tours', 'Pannes', 'Rembercourt-sur-Mad', 'Saint-Baussant',
              'Saint-Julien-lès-Gorze', 'Seicheprey', 'Thiaucourt-Regniéville',
              'Viéville-en-Haye', 'Xammes',
            ]
            this.villesParent2 = response.data.filter(v => !exclusions.includes(v.nom))
          })
          .catch(console.log)
      }
    },

    valideCommuneParent1() {
      axios
        .get(
          'https://api-adresse.data.gouv.fr/search/?q=' +
            this.communeParent1 +
            '&type=municipality&postcode=' +
            this.codePostalParent1,
        )
        .then(response => (this.codeVille = response.data))
        .catch(console.log)
    },

    valideCommuneParent2() {
      axios
        .get(
          'https://api-adresse.data.gouv.fr/search/?q=' +
            this.communeParent2 +
            '&type=municipality&postcode=' +
            this.codePostalParent2,
        )
        .then(response => (this.codeVille = response.data))
        .catch(console.log)
    },

    valideRueParent1() {
      if (this.adresseParent1.length >= 5) {
        const citycode = this.codeVille.features[0].properties.citycode
        this.fenetreParent1 = true
        axios
          .get(
            'https://api-adresse.data.gouv.fr/search/?q=' +
              this.adresseParent1 +
              '&citycode=' +
              citycode,
          )
          .then(response => {
            if (response.data.features[0]) {
              this.ruesParent1 = response.data
            }
          })
          .catch(console.log)
      }
    },

    valideRueParent2() {
      if (this.adresseParent2.length >= 5) {
        const citycode = this.codeVille.features[0].properties.citycode
        this.fenetreParent2 = true
        axios
          .get(
            'https://api-adresse.data.gouv.fr/search/?q=' +
              this.adresseParent2 +
              '&citycode=' +
              citycode,
          )
          .then(response => {
            if (response.data.features[0]) {
              this.ruesParent2 = response.data
            }
          })
          .catch(console.log)
      }
    },

    valideStepOne() {
      this.showRecap = true
      window.scrollTo(0, 0)
    },

    valideStepTwo() {
      if (null !== this.geocodeParent1 && this.adresseParent1 !== this.geocodeParent1.properties.name) {
        this.longitudeParent1 = null
        this.latitudeParent1 = null
      }
      if (null !== this.geocodeParent2 && this.adresseParent2 !== this.geocodeParent2.properties.name) {
        this.longitudeParent2 = null
        this.latitudeParent2 = null
      }

      axios
        .post('formulaire', {
          photoEleve: this.photoEleve,
          genreEleve: this.genreEleve,
          nomEleve: this.nomEleve,
          prenomEleve: this.prenomEleve,
          naissanceEleve: this.naissanceEleve,
          genreParent: this.genreParent,
          nomParent: this.nomParent,
          prenomParent: this.prenomParent,
          nomPrenomParent2: this.nomPrenomParent2,
          adresseParent1: this.adresseParent1,
          adresseParent2: this.adresseParent2,
          complementParent1: this.complementParent1,
          complementParent2: this.complementParent2,
          codePostalParent1: this.codePostalParent1,
          codePostalParent2: this.codePostalParent2,
          communeParent1: this.communeParent1,
          communeParent2: this.communeParent2,
          longitudeParent1: this.longitudeParent1,
          latitudeParent1: this.latitudeParent1,
          longitudeParent2: this.longitudeParent2,
          latitudeParent2: this.latitudeParent2,
          telephone: this.telephone,
          email: this.email,
          aboInfoReseauEmail: this.aboInfoReseauEmail,
          gardeAlternee: this.gardeAlternee,
          etablissement: this.etablissement === null ? null : this.etablissement.id,
          etablissementAutre: this.etablissementAutre,
          classe: this.classe.id,
          regime: this.regime,
          tmsTitreRechargementId: this.rechargementId,
          typeDemande: this.demande,
        })
        .then(() => router.push({ name: 'succes' }))
        .catch(() => router.push({ name: 'erreur' }))
    },

    selectReponse(adresseSelectionneeParent1) {
      this.adresseParent1 = adresseSelectionneeParent1.features[0].properties.name
      this.geocodeParent1 = adresseSelectionneeParent1.features[0]
      this.longitudeParent1 = this.geocodeParent1.geometry.coordinates[0]
      this.latitudeParent1 = this.geocodeParent1.geometry.coordinates[1]
    },

    selectReponseParent2(adresseSelectionneeParent2) {
      this.adresseParent2 = adresseSelectionneeParent2.features[0].properties.name
      this.geocodeParent2 = adresseSelectionneeParent2.features[0]
      this.longitudeParent2 = this.geocodeParent2.geometry.coordinates[0]
      this.latitudeParent2 = this.geocodeParent2.geometry.coordinates[1]
    },

    retour() {
      this.showRecap = false
      window.scrollTo(0, 0)
    },

    closeFenetre() {
      this.fenetreParent1 = false
      this.fenetreParent2 = false
    },

    uploadImage(event) {
      const data = new FormData()
      const file =
        event.dataTransfer !== undefined ? event.dataTransfer.files[0] : event.target.files[0]
      data.append('file', file)
      data.append('wanted', 'image/jpeg')

      axios
        .post('upload', data)
        .then(response => {
          this.photoEleveUrl = 'upload/' + response.data
          this.photoEleve = response.data
        })
        .catch(reason => {
          alert(
            "Erreur lors de l'envoi de votre fichier, veuillez recommencer.\n vérifiez : la taille ( max. 5Mo ) et le format de votre fichier.",
          )
          console.log(reason)
          if (this.$refs.filePhoto) this.$refs.filePhoto.value = ''
          this.photoEleve = null
          this.photoEleveUrl = avatarUrl
        })
    },

  },

  mounted() {
    if (this.isReinscription) {
      this.rechargementId = this.$store.state.rechargementId
      this.genreEleve = this.$store.state.civilite
      this.nomEleve = this.$store.state.nom
      this.prenomEleve = this.$store.state.prenom
      this.naissanceEleve = this.$store.state.dateNaissance
    }

    this.demande = this.isReinscription ? 'REINSCRIPTION' : 'INSCRIPTION'

    axios
      .get('etablissements')
      .then(response => {
        const etablissements = []
        if (this.$route.name === 'formulaire-cas-1' || this.$route.name === 'reinscription-formulaire-cas-1') {
          etablissements.push(response.data[0], response.data[1])
        } else if (
          this.$route.name === 'formulaire-cas-2' ||
          this.$route.name === 'reinscription-formulaire-cas-2'
        ) {
          etablissements.push(response.data[2], response.data[3])
        }
        this.etablissementsDonnees = etablissements
      })
      .catch(console.log)

    axios
      .get('classes')
      .then(response => {
        const classes = []
        if (this.$route.name === 'formulaire-cas-1' || this.$route.name === 'reinscription-formulaire-cas-1') {
          classes.push(response.data[0], response.data[1])
        } else if (
          this.$route.name === 'formulaire-cas-2' ||
          this.$route.name === 'reinscription-formulaire-cas-2'
        ) {
          classes.push(response.data[2], response.data[3])
        } else if (
          this.$route.name === 'formulaire-cas-3' ||
          this.$route.name === 'reinscription-formulaire-cas-3'
        ) {
          classes.push(response.data[2], response.data[3])
        }
        this.classesDonnees = classes
      })
      .catch(console.log)

    document.addEventListener('click', this.closeFenetre)
  },

  unmounted() {
    document.removeEventListener('click', this.closeFenetre)
  },
}
</script>

<style lang="scss">
@import '../sass/app';

.formulaire {
  @include card_shadow;
  padding: 2rem;
  margin-top: 1rem;
  margin-bottom: 2rem;

  .div_sous_titre {
    display: flex;

    .sous_titre {
      margin: 1rem auto 1rem auto;
      display: flex;

      .titre_parties {
        margin: auto 10px auto 0;
        color: $firstcolor;
        text-align: center;
      }
    }
  }

  .champ {
    margin-bottom: 1rem;
    display: flex;
    @include media-breakpoint-down(sm) {
      display: block;
    }

    .label {
      margin: auto auto auto 0;
      color: $secondcolor;
      font-family: $textfont;
    }

    .input {
      margin: auto 0 auto auto;
    }

    ::placeholder {
      color: #d3d3d3;
    }
  }

  .champ:focus-within {
    .label {
      color: $firstcolor;
    }
  }

  .div_info_etablissement_scolaire {
    display: flex;
    width: 100%;

    #info_etablissement_primaire {
      margin: auto;
      font-size: 14px;
      color: grey;

      #lien_fluo {
        color: grey;
      }
    }
  }

  .div_twobtns {
    display: flex;

    .boutons_fin {
      margin: auto;
      @include boutons;
    }

    .boutons_fin:hover {
      @include boutons_hover;
    }

    .div_retour,
    .div_suivant {
      display: flex;
      margin: auto;
    }
  }

  .fenetre_autocomplete {
    .proposition {
      width: 100%;
      background-color: white;
      color: $firstcolor;
    }

    .proposition:hover {
      color: white;
      background-color: $firstcolor;
    }

    z-index: 1;
    position: absolute;
    width: 75%;
    border-radius: 5px;
  }
}

.info_garde_alternee {
  margin-left: 3rem;
}

.bloc_intro_renseignements {
  margin: auto;
  text-align: center;
  background-color: #ead1e6;
  border-radius: 25px;
  padding: 4rem 2rem 4rem 2rem;
}

.liens_reglements_mentions {
  color: grey;
  font-size: 14px;
}

.liens_reglements_mentions:hover {
  color: grey;
}

.div_photo_input {
  @include media-breakpoint-down(md) {
    display: block !important;
  }

  #photoEleve {
    @include media-breakpoint-down(md) {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
